/**
 * Everything the browser must wire before the first render.
 *
 * Module scope, not an effect: a store or an API call issued during the first render must
 * not find null. Imported first by main.tsx.
 */
import { setStores } from '@/storage/projectStorePort';
import { configureApi } from './api/client';
import { accessToken, configureAuth } from './api/auth';
import { IndexedDbProjectStore, IndexedDbChatStore } from './platform/projectStore.idb';

setStores({ projects: IndexedDbProjectStore, chat: IndexedDbChatStore });

/*
 * Read from the same variables the bundle was built with. web/env.ts refuses a production
 * build without API_URL, BUILD_URL and the Cognito pair, so these are present in any real
 * release — the fallbacks are only for a dev server run without a full backend.
 *
 * buildUrl comes from the SAME variable the shared buildClient reads, so the old path and
 * the new typed client cannot disagree about where the build service is. Disagreeing was
 * the bug: BUILD_URL was missing from the bundle entirely and every build ended with
 * "this build needs a connection and has none".
 */
configureAuth({
  userPoolId: process.env.EXPO_PUBLIC_COGNITO_USER_POOL_ID ?? '',
  clientId: process.env.EXPO_PUBLIC_COGNITO_CLIENT_ID ?? '',
});

configureApi({
  apiUrl: process.env.EXPO_PUBLIC_API_URL ?? '',
  buildUrl: process.env.EXPO_PUBLIC_BUILD_URL ?? '',
  llmUrl: process.env.EXPO_PUBLIC_LLM_URL ?? '',
  // The ACCESS token: the API verifies token_use === 'access' and rejects an ID token with
  // a 401 even though the same pool signed it.
  getToken: accessToken,
});
